<template>
  <div class="stpe3">
    <info-panel class="info">
      <span class="avatar">
        <el-image
          class="avatar"
          :src="info.wechatAvatarUrl "
        />
      </span>
      <span class="info-item">
        手机号码:<b>{{ info.mobilePhone }}</b>
      </span>
      <span class="info-item">
        微信昵称:<b>{{ info.wechatNickName }}</b>
      </span>
    </info-panel>
    <form-title>权限管理</form-title>
    <info-panel>
      <div class="item-list">
        <div
          v-for="item in permissionList"
          :key="item.id"
          class="item"
        >
          <div class="title">
            {{ item.permissionName }}
          </div>
          <div class="check-list">
            <el-checkbox
              v-for="son in item.sonList"
              :key="son.id"
              v-model="son.isSelected"
            >
              {{ son.permissionName }}
            </el-checkbox>
          </div>
        </div>
      </div>
      <el-row :gutter="20">
        <el-col class="btns">
          <el-button @click="prev">
            上一步
          </el-button>
          <el-button
            type="primary"
            @click="next"
          >
            保存
          </el-button>
        </el-col>
      </el-row>
    </info-panel>
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import formTitle from '@/components/common/formTitle.vue';
import axClient from '@/services';

export default {
  name: 'CreatStep1',
  components: { infoPanel, formTitle },
  props: {
    info: {
      default: () => ({
        id: '',
        mobilePhone: '',
        wechatNickName: '',
        wechatAvatarUrl: '',
      }),
      type: Object,
    },
  },
  data() {
    return {
      permissionList: [],
      isEdit: !!this.$route.params.id,
    };
  },
  mounted() {
    this.getPermissionList();
    if (this.isEdit) {
      this.permissionList = this.form;
    }
  },
  methods: {
    // 上一步
    prev() {
      this.$emit('prev', 2);
    },
    // 下一步
    next() {
      this.$emit('next', this.formatPermissionList());
    },
    // 取出isSelected 为true的权限
    formatPermissionList() {
      const list = [];
      this.permissionList.forEach((item) => {
        const obj = {
          id: item.id,
          sonList: [],
        };
        if (item.sonList) {
          item.sonList.forEach((son) => {
            if (son.isSelected) {
              obj.id = item.id;
              obj.sonList.push(
                {
                  id: son.id,
                  isSelected: 1,
                },
              );
            }
          });
        }
        if (obj.sonList.length > 0) {
          list.push(obj);
        }
      });
      return list;
    },
    // 查询权限列表
    async getPermissionList() {
      this.permissionList = await axClient.account.permissionList({
        needHideUnSelect: false,
        userId: this.isEdit ? this.info.id : null,
      });
      this.permissionList.forEach((v) => {
        if (v.sonList) {
          v.sonList.forEach((son) => {
            son.isSelected = son.isSelected === 1;
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.stpe3 {
  .info {
    display: flex;
    align-items: center;
    color: $--base-color-black;
    font-size: 14px;
    margin-bottom: 20px;
    .info-item {
      margin-left: 40px;
      b {
        margin-left: 10px;
      }
    }
    .avatar {
      img {
        border-radius: 50%;
        display: inline-block;
        width: 32px;
        height: 32px;
        background: #eee;
      }
    }
  }
  .item-list {
    .item {
      margin-bottom: 15px;
      .title {
        font-size: 16px;
        font-weight: 500;
        padding-bottom: 10px;
      }
    }
  }
}
</style>